import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';

import { getUsers } from 'services/UserService';

import { ApiStatus } from 'constants/enums';
import type { User } from 'models/user.interface';
import { handleApiErrors } from 'utils/errorUtils';

export interface UsersState {
  details: {
    data: User[];
    status: ApiStatus;
  }
}

const initialState: UsersState = {
  details: {
    data: [],
    status: ApiStatus.idle,
  }
};

export const fetchUsers = createAsyncThunk(
  'users/fetchUsers',
  async (_, thunkAPI) => {
    try {
      const response = await getUsers();
      return response?.data?.users || [];
    } catch (e) {
      handleApiErrors(e);
      return thunkAPI.rejectWithValue(e);
    }
  },
);

export const usersSlice = createSlice({
  name: 'users',
  initialState,
  reducers: {},
  extraReducers(builder) {
    builder
      .addCase(fetchUsers.pending, (state) => {
        state.details = {
          ...state.details,
          status: ApiStatus.loading,
        };
      })
      .addCase(fetchUsers.fulfilled, (state, action) => {
        state.details = {
          data: action.payload,
          status: ApiStatus.idle,
        };
      })
      .addCase(fetchUsers.rejected, (state) => {
        state.details = {
          ...state.details,
          status: ApiStatus.idle,
        };
      });
  }
});

export default usersSlice.reducer;
